import React from 'react';
import ReportCodes from '../../../components/reports/ReportCodes';
import PageBarReport from '../../components/PageBarReport';

const VerteilungNachSpartenbereiche = () => {
    return (
        <PageBarReport
            title="Verteilung nach Spartenbereichen"
            reportCode={ReportCodes.DistributionPerSectionAreas}
        />
    );
};

export default VerteilungNachSpartenbereiche;
